import { SelectChangeEvent } from "@mui/material";

export interface FormField<T = any> {
  name: keyof T;
  label: string;
  type:
    | 'input'
    | 'textarea'
    | 'select'
    | 'radio'
    | 'checkbox'
    | 'number'
    | 'email'
    | 'date'
    | 'switch'
    | 'file'
    | 'autocomplete'
    | 'wysiwyg'
    | 'dynamicList'
    | 'offerOptions';
  value?: any;
  placeholder?: string;
  helperText?: string;
  error?: boolean;
  // Opcje dla pól select i radio
  options?: Array<{ label: string; value: string | number; description?: string }>;
  // Dodatkowe opcje dla textarea
  rows?: number;
  // Opcje dla pola file (np. 'image/*')
  accept?: string;
  loading?: boolean;
  group?: string;
  format?: string;
  multiple?: boolean;
  itemFields?: FormField<any>[];
  optionTypes?: any[];
  sx?: React.CSSProperties;
  disabled?: boolean;
  hidden?: boolean;
  readonly?: boolean; // For fields that should be visible but not editable
  direction?: 'ltr' | 'rtl';
  inputProps?: React.InputHTMLAttributes<HTMLInputElement>;
}

export interface FormRendererProps {
  fields: FormField[];
  onChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent<string>,
    child?: React.ReactNode
  ) => void;
  customFilterOptions?: {
    [fieldName: string]: (options: any[], state: { inputValue: string }) => any[];
  };
  autocompleteInputChangeHandlers?: {
    [fieldName: string]: (inputValue: string, reason?: 'input' | 'clear' | 'open') => void;
  };
  autocompleteResetKeys?: Record<string, number>;
}

export enum FormRenderTypes {
	input = "input",
	textarea = "textarea",
	select = "select",
	radio = "radio",
	checkbox = "checkbox",
	number = "number",
	email = "email",
	date = "date",
	switch = "switch",
	file = "file",
	autocomplete = "autocomplete",
	wysiwyg = "wysiwyg",
	dynamicList = "dynamicList",
	offerOptions = "offerOptions",
}
